<div class="product-grid">
  @for (product of products; track product.productId) {
    <lib-bundle-product-list-item
      [product]="product"
      [selectedProducts]="selectedProducts"
      [bundleSize]="bundleSize"
      (increment)="increment.emit($event)"
      (decrement)="decrement.emit($event)"
    />
  }
</div>
